import { DOCK_CATEGORIES_TYPES } from '../../../../types/dockTypes'
import { useLicensedWidgets } from '../../../../hooks/useLicensedWidgets'
import { LicensedWidgetsSection } from '../licensed-widgets-section'
import { SECTION_TITLES } from '../../utils/widgetsByCategory'

export const MilkYieldTableContainer = () => {
	const widgets = useLicensedWidgets(DOCK_CATEGORIES_TYPES.MILK_YIELD)
	return (
		<LicensedWidgetsSection
			widgets={widgets}
			title={SECTION_TITLES[DOCK_CATEGORIES_TYPES.MILK_YIELD]}
		/>
	)
}
